import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const allNavItems = [
  { path: '/', icon: '📊', label: 'Dashboard', roles: ['admin','manager','staff'] },
  { path: '/inventory', icon: '🚗', label: 'Inventory', roles: ['admin','manager','staff'] },
  { path: '/vehicles/add', icon: '➕', label: 'Add Vehicle', roles: ['admin','manager','staff'] },
  { path: '/customers', icon: '👥', label: 'Customers', roles: ['admin','manager'] },
  { path: '/deals', icon: '🤝', label: 'Deals', roles: ['admin','manager'] },
  { path: '/import', icon: '📥', label: 'Import CSV', roles: ['admin','manager'] },
  { path: '/users', icon: '👤', label: 'Team', roles: ['admin'] },
  { path: '/reports', icon: '📈', label: 'Reports', roles: ['admin','manager'] },
  { path: '/feed', icon: '📡', label: 'Website Feed', roles: ['admin'] },
  { path: '/settings', icon: '⚙️', label: 'Settings', roles: ['admin','manager','staff'] },
];

export default function Sidebar({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const role = user?.role || 'staff';
  const navItems = allNavItems.filter(item => item.roles.includes(role));

  const goTo = (path) => { navigate(path); setOpen(false); };

  return (
    <>
      {/* Mobile top bar */}
      <div style={{ display: 'none', position: 'fixed', top: 0, left: 0, right: 0, height: 56, background: '#111', borderBottom: '1px solid #222', zIndex: 200, alignItems: 'center', justifyContent: 'space-between', padding: '0 16px' }} className="mobile-topbar">
        <h2 style={{ color: '#cc0000', fontSize: 18, fontWeight: 800, letterSpacing: 1 }}>RED ZONE</h2>
        <button onClick={() => setOpen(!open)} style={{ background: 'none', border: '1px solid #333', borderRadius: 6, color: '#e0e0e0', padding: '6px 12px', cursor: 'pointer', fontSize: 18 }}>☰</button>
      </div>

      {/* Mobile overlay */}
      {open && <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.7)', zIndex: 150 }} className="mobile-overlay" />}

      {/* Sidebar */}
      <div className="sidebar-nav-container" style={{ width: 220, background: '#111', borderRight: '1px solid #222', display: 'flex', flexDirection: 'column', position: 'fixed', height: '100vh', zIndex: 160, overflowY: 'auto', transition: 'transform .3s' }}>
        <div style={{ padding: 20, borderBottom: '1px solid #222' }}>
          <h2 style={{ color: '#cc0000', fontSize: 20, fontWeight: 800, letterSpacing: 1 }}>RED ZONE</h2>
          <p style={{ color: '#555', fontSize: 11, marginTop: 2 }}>DMS Platform</p>
        </div>
        <nav style={{ flex: 1, padding: '16px 0' }}>
          {navItems.map(item => {
            const active = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
            return (
              <div key={item.path} onClick={() => goTo(item.path)}
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 20px', color: active ? '#cc0000' : '#888', cursor: 'pointer', fontSize: 14, borderLeft: `3px solid ${active ? '#cc0000' : 'transparent'}`, background: active ? '#1a0000' : 'transparent' }}>
                <span style={{ fontSize: 18, width: 20, textAlign: 'center' }}>{item.icon}</span>
                {item.label}
              </div>
            );
          })}
        </nav>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #222' }}>
          <div style={{ background: '#1a1a1a', borderRadius: 8, padding: 10, fontSize: 12, color: '#888', marginBottom: 10 }}>
            <strong style={{ color: '#e0e0e0', display: 'block', marginBottom: 2 }}>{user?.dealer_name || 'Dealership'}</strong>
            <span>{user?.name || ''}</span>
          </div>
          <button onClick={onLogout} style={{ width: '100%', padding: 8, background: 'transparent', border: '1px solid #333', borderRadius: 6, color: '#888', cursor: 'pointer', fontSize: 12 }}>Sign Out</button>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .mobile-topbar { display: flex !important; }
          .sidebar-nav-container { transform: translateX(${open ? '0' : '-100%'}); top: 0; }
        }
      `}</style>
    </>
  );
}
